import styled, { css } from 'styled-components';

export const NewsImage = styled.div`
  width: 100%;
  height: 260px;
  top: 0;
  left: 0;
  background: url(${({ src }) => src}) no-repeat center top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  border-radius: 16px;

  @media ${props => props.theme.device.tablet} {
    width: 228px;
    height: 212px;
  }

  @media ${props => props.theme.device.mobile} {
    width: 100%;
    height: 233px;
  }
`;

export const NewsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NewsDetails = styled.div``;

export const NewsLabel = styled.div``;

export const NewsTitle = styled.div`
  margin-top: 10px;
  display: -webkit-box;
  height: 60px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media ${props => props.theme.device.mobile} {
    height: 40px;
    -webkit-line-clamp: 2;
  }
`;

export const NewsDate = styled.div``;

export const NewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  width: 280px;
  height: 400px;
  border-radius: 24px;
  padding: 16px;
  cursor: pointer;

  @media ${props => props.theme.device.tablet} {
    width: 228px;
    height: 346px;
  }
  @media ${props => props.theme.device.mobile} {
    width: 100%;
    height: 388px;
  }

  ${({ isInterest }) =>
    isInterest &&
    css`
      @media ${props => props.theme.device.mobile} {
        width: 251px;
        height: 388px;
      }

      ${NewsTitle} {
        @media ${props => props.theme.device.tablet} {
          height: 60px;
          -webkit-line-clamp: 3;
        }

        @media ${props => props.theme.device.mobile} {
          height: 60px;
          -webkit-line-clamp: 3;
        }
      }

      ${NewsImage} {
        height: 180px;
      }

      ${NewsDate} {
        @media ${props => props.theme.device.tablet} {
          margin-top: 20px;
        }
        @media ${props => props.theme.device.mobile} {
          margin-top: 20px;
        }
      }
    `}

  ${NewsDetails} {
    padding-top: 16px;
  }

  ${({ isRecent }) =>
    isRecent &&
    css`
      ${NewsImage} {
        height: 180px;
      }

      ${NewsDetails} {
        padding-top: 30px;
      }

      ${NewsLabel} {
        display: initial;
        text-transform: uppercase;
      }

      ${NewsTitle} {
        margin-top: 10px;

        @media ${props => props.theme.device.tablet} {
          height: 40px;
          -webkit-line-clamp: 2;
        }

        @media ${props => props.theme.device.mobile} {
          height: 60px;
          -webkit-line-clamp: 3;
        }
      }

      ${NewsDate} {
        @media ${props => props.theme.device.tablet} {
          margin-top: 20px;
        }
        @media ${props => props.theme.device.mobile} {
          margin-top: 20px;
        }
      }

      @media ${props => props.theme.device.tablet} {
        width: 100%;
        flex-direction: row;
        height: 180px;

        ${NewsImage} {
          width: 313px;
          height: 180px;
        }
      }

      @media ${props => props.theme.device.mobile} {
        width: 100%;
        height: 400px;

        ${NewsImage} {
          width: 100vw;
          height: 180px;
        }
      }
    `}
`;
